export default "__VITE_ASSET__67ab3d75__"